import styled from 'styled-components'
import Slider from 'react-slick'

export const ProductPictureSmall = styled.img`
  width: 100%;
  height: 100%;
  @media screen and (min-width: 1100px) {
  }
`

export const ProductGalleryDesktop = styled.div`
  border: 1px solid #f2f4f8;
  border-radius: 6px;
  padding: 40px 0px;
  padding-top: 0px;

  /* .slick-list {
    max-height: 500px;
  } */

  img {
    /* max-height: 500px;
    object-fit: scale-down; */
  }

  .slick-dots {
    margin-top: 8px;
  }

  @media screen and (min-width: 1100px) {
  }
`

export const ProductGallery = styled.div`
  .product-image {
    width: 100%;
    height: 100%;

    img {
      max-height: 550px;
    }
  }

  @media screen and (min-width: 1100px) {
    display: none;
  }
`

export const ProductImageSlider = styled(Slider)`
  display: grid !important;

  @media screen and (min-width: 768px) {
    .slick-dots {
      position: static;
      display: block;

      li {
        width: 80px;
        height: 80px;
        padding: 10px;
        border: 1px solid #eaeaea;
        box-sizing: border-box;
        background-color: white;

        img {
          object-fit: contain;
        }
      }
    }

    .product-image {
      display: flex !important;
      justify-content: center;
      margin-bottom: 8px;
      div {
        outline: none;
      }

      img {
        max-height: 550px;
        object-fit: contain;
      }
    }
  }
`

export const ColorSelectorWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
`
export const ColorBox = styled.div`
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  ${({ active }) => active && `border: 1px solid black;`}
`

export const ColorButton = styled.button`
  width: 15px;
  height: 15px;
  border: ${({ color }) => `1px solid ${color || '#999'}`};
  background-color: ${({ color }) => color || 'rgba(128,128,128,0.3)'};
  cursor: pointer;
`
